const nameSpace = 'auth/'

const Types = {
    getters: {
        GET_USER_NAME: `${nameSpace}GET_USER_NAME`,
        IS_ADMIN: `${nameSpace}IS_ADMIN`,
    },
    mutations: {
        SET_ACCOUNT_ID: `${nameSpace}SET_ACCOUNT_ID`,
        SET_ACCOUNT_PERMISSION: `${nameSpace}SET_ACCOUNT_PERMISSION`,
        SET_USER: `${nameSpace}SET_USER`,
        REDIRECT_FORBIDDEN: `${nameSpace}REDIRECT_FORBIDDEN`,
        APP_VERSION_CHANGED: `${nameSpace}APP_VERSION_CHANGED`,
        RESET_STATE: `${nameSpace}RESET_STATE`,
    },
    actions: {
        GET_CHECK: `${nameSpace}GET_CHECK`,
        LOG_OUT: `${nameSpace}LOG_OUT`,
        REMOVE_ACCOUNT_DATA: `${nameSpace}REMOVE_ACCOUNT_DATA`,
    },
}

export {
    nameSpace, Types
}
